export const CAMPAIGN_STATE_NEW = 'new';
export const CAMPAIGN_STATE_DRAFT = 'draft';
export const CAMPAIGN_STATE_LAUNCHED = 'launched';
export const CAMPAIGN_STATE_COMPLETED = 'completed';
export const CAMPAIGN_STATE_STASHED = 'stashed';

export const DEFAULT_PAYMENT_TERMS = 'NET_30';
